import { PIT_STATS_SUCCESS, PIT_STATS_FAILURE, PIT_STATS_REQUEST, PIT_STATS_RESET } from './constant';

export const pitStatsSuccess = (payload) => ({ type: PIT_STATS_SUCCESS, payload });
export const pitStatsFailure = (payload) => ({ type: PIT_STATS_FAILURE, payload });
export const pitStatsRequest = (pitNumber) => ({ type: PIT_STATS_REQUEST, payload: { pitNumber } });
export const pitStatsReset = () => ({ type: PIT_STATS_RESET });
